import { Button } from "@components/button";
import { Input } from "@components/input";
import { useAuth } from "@features/auth";
import { RegisterForm as RegisterFormType } from "@features/auth/api";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { registerSchema } from "../schemes";
import styles from "./register.module.scss";

export const RegisterForm = () => {
  const { register } = useAuth();

  const navigate = useNavigate();

  const { control, handleSubmit, setError, formState } =
    useForm<RegisterFormType>({
      resolver: yupResolver(registerSchema),
      defaultValues: { email: "", password: "", password_confirmation: "" },
    });

  const onSubmit = async (data: RegisterFormType) => {
    try {
      await register(data);

      navigate("success");
    } catch (error) {
      switch (error) {
        case "transaction failed: server error: EMAIL_EXISTS":
          setError("email", {
            type: "server",
            message: "Данный email занят",
          });
          break;
        case "INVALID_LOGIN_CREDENTIALS":
          setError("email", {
            type: "server",
            message: "Неверный email либо пароль",
          });
          break;
      }
    }
  };

  return (
    <form className={styles.form}>
      <Input
        label="E-mail"
        name="email"
        control={control}
        placeholder="Введите e-mail"
        className={styles.input}
      />
      <Input
        label="Пароль"
        type="password"
        name="password"
        control={control}
        placeholder="Введите пароль"
        className={styles.input}
      />
      <Input
        label="Повторить пароль"
        type="password"
        name="password_confirmation"
        control={control}
        placeholder="Повторите пароль"
        className={styles.input}
      />
      <Button
        className={styles.button}
        onClick={handleSubmit(onSubmit)}
        disabled={formState.isSubmitting}
      >
        Зарегистроваться
      </Button>
    </form>
  );
};
